import * as React from 'react';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';

import Logo from '@itp/assets/logo.svg';
import { getRoutingPath, ROUTES } from '@itp/talent/constants/routingPath';

import { TopNavigation } from '../navigation';
import { MobileMenu } from './components';
import { HomeLink, StyledToolbar, TopBarWrapper } from './topBar.styles';

export const TopBar: React.FC = () => {
  return (
    <TopBarWrapper>
      <AppBar
        color="transparent"
        elevation={0}
        position="static"
        sx={{ background: 'none', borderBottom: 'none', marginBottom: '2px', maxWidth: '1280px' }}
      >
        <StyledToolbar disableGutters>
          <HomeLink href={getRoutingPath(ROUTES.HOMEPAGE)}>
            <Logo />
          </HomeLink>
          <Box sx={{ flexGrow: 1 }} />
          <TopNavigation />
          <MobileMenu />
        </StyledToolbar>
      </AppBar>
    </TopBarWrapper>
  );
};
